
import {Component, Vue} from "vue-property-decorator";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import {ITask, ITasks, PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {Socket} from "vue-socket.io-extended";
import {uyapEngelMetniMi} from "@/plugins/uyap-plugin/UyapEngeli";

@Component({
  components: {}
})
export default class TakipSorgulaIslemDetayView extends Vue {
  // TODO: al görev sonuçlarının görülebileceği detay ekranı / bütün sonuçların görünebileceği alan
  @Socket('updateTasks')
  onUpdateTask() {
    this.load();
  }

  onFly = false;
  downloading = false;
  headers = [
    {text: 'Esas No', value: 'esasNo'},
    {text: 'Birim Adı', value: 'birimAdi'},
    {text: 'Sorgulanacak Alanlar', value: 'sorguAlanlari'},
    {text: 'Açıklama', value: 'description'},
    {text: 'Durum', value: 'status'},
  ];
  seciliHataliGorevler = [];
  items = [];
  loading = false;
  hataliHeaders = [
    {text: 'Esas No', value: 'esasNo'},
    {text: 'Birim Adı', value: 'birimAdi'},
    {text: 'Sorgulanacak Alanlar', value: 'sorguAlanlari'},
    {text: 'Açıklama', value: 'description'},
    {text: 'Durum', value: 'status'},
  ];
  taskDurum = TaskDurum;
  programPaths = ProgramPaths;
  playerDurum = PlayerDurum;

  get isFirstTask(): boolean {
    return this.$store.getters.getSiradakiGorevler[0]?.id == this.$route.params.id;
  }

  get paternTask(): ITask {
    let tasks: ITasks = this.$store.getters.getGorevler;
    let allTaskt: Array<ITask> = [...tasks.incomplete_tasks, ...tasks.completed_tasks];
    return allTaskt.find((task: ITask) => task.id == Number(this.$route.params.id)) as ITask;
  }

  async mounted(){
    await this.load();
  }

  async load() {
    try {
      this.loading = true;
      this.items = (await this.$http.get('/api/v1/task/' + this.$route.params.id + '/child-tasks')).data;
    } catch (e) {
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  async downloadExcel() {
    try {
      this.downloading = true;
      await this.$helper.download('Excel Sonuçlar.xlsx', '/api/v1/export-to-excel/' + this.$route.params.id);
      this.$toast.success('Excel dosyası başarıyla indirildi.');
    } catch (error) {
      console.error('Excel indirme hatası:', error);
      this.$toast.error('Excel dosyası oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      this.downloading = false;
    }
  }

  /** UYAP insan doğrulaması engelinde biten dosya (K1-A: açıklama UYAP'ın özgün metni): "UYAP Engeli" rozeti. */
  engelMi(item: any): boolean {
    return uyapEngelMetniMi(item && item.description);
  }

  async durdurDevamEt() {
    if (this.$store.getters.getPlayerDurum == this.playerDurum.oto) {
      this.$socket.client.emit("player", this.playerDurum.durduruluyor);
    } else {
      await this.$store.dispatch("playerBaslatOnayli", this.$socket.client);
    }
  }

  selectAllToggle() {
    let hatalilar = this.items.filter((item: ITask) => (item.status == this.taskDurum.BITTI_HATALI || item.status == this.taskDurum.BITTI_EKSIK));
    if (this.seciliHataliGorevler.length == hatalilar.length) {
      this.seciliHataliGorevler = [];
    } else {
      this.seciliHataliGorevler = hatalilar;
    }
  }

  async tryAgainCreateTask() {
    if (this.seciliHataliGorevler.length > 0) {
      this.onFly = true;
      let tasks: Array<ITask> = [];
      this.seciliHataliGorevler.forEach((item: any) => {
        let task: ITask = {...item};
        task.id = null;
        if (task.status == TaskDurum.BITTI_EKSIK)
          task.data.sorguAlanlari = (task.data?.sorguAlanlari || []).filter((alan: any) => (task.response?.data?.hataliSorguAlanlari || []).some((hataliAlan: any) => hataliAlan.name == alan.name));
        task.status = TaskDurum.SIRADA;
        task.response = null;
        task.parent_id = null;
        tasks.push(task);
      });
      tasks[0].aciklama = "Hatalı sorguların yeniden sorgulanması.";
      try {
        await this.$store.dispatch('postTasks', tasks);
        let req = {
          ids: this.seciliHataliGorevler.map((gorev: ITask) => gorev.id),
          status: TaskDurum.YENIDEN_BASLATILDI
        };
        await this.$http.post('/api/v1/task/update-status', req);
        await this.$store.dispatch('getTasksFromServer');
        await this.load();
        await this.$router.push(ProgramPaths.eicrapro + '/islemler');
      } catch (e) {
        console.error(e)
      } finally {
        this.seciliHataliGorevler = [];
        this.onFly = false;
      }
    } else {
      this.$toast.info('Yeniden başalatılacak görevleri seçiniz.')
    }
  }

  getSorguAlanlari(item: any) {
    return item && item.data && Array.isArray(item.data.sorguAlanlari) ? item.data.sorguAlanlari : [];
  }

  getHataliAlanlar(item: any) {
    const hatalilar = item && item.response && item.response.data && Array.isArray(item.response.data.hataliSorguAlanlari)
        ? item.response.data.hataliSorguAlanlari
        : [];
    return hatalilar;
  }
}
